<template>
  <div class="editor">
    <jodit-vue v-model="internalNote" :buttons="buttons" class="form-control" :name="machine_name"></jodit-vue>
  </div>
</template>

<script>
import 'jodit/build/jodit.min.css'
import { JoditVue } from 'jodit-vue'

export default {
  components: {JoditVue},
  props: ['internal_note_loaded', 'machine_name'],
  data() {
    return {
      buttons: ['bold', 'underline', 'italic', 'eraser', 'ul', 'ol', 'fontsize', 'link'],
      internalNote: this.internal_note_loaded,
      editOrAdd: 'Add',
      originalInternalNote: this.internal_note_loaded,
    }
  },
  methods: {
    saveInternalNote: function() {
      let that = this;
      window.axios({
        method: 'POST',
        url: this.actionurl,
        data: {
          internal_note: that.internalNote
        }
      }).then(function(response) {
        that.originalInternalNote = that.internalNote;
        that.$emit('closeModal', that.internalNote);
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    closeInternalNote: function() {
      this.internalNote = this.originalInternalNote;
      this.$emit('closeModal', this.internalNote);
    }
  }
}
</script>
